
import { controls } from "../../controls";

const rp102 = {
  label: "Account Statement",
  starting: true,
  url: "rp102",
  pageLabel: "Account Statement",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", width: "col-sm-2", name: "branch_display", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", width: "col-sm-2" }),
    ...controls.showData({
      tab: "filter", data: "product_code_display", width: "col-sm-2"
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      isRequired: true,
      displayData: { descn: "account_number_display", account_number_guid: 'account_number_guid', product_code_guid: "product_code_guid", },
      beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "filter", data: "account_number_display", width: "col-sm-2" }),
    // {
    //   inputType: "checkbox",
    //   tab: "filter",
    //   widths: {
    //     parent: "col-sm-2",
    //     children: "col-sm-12"
    //   },
    //   placeHolder: "Active",
    //   label: "Customer",
    //   name: "isCustomer",
    //   description: "Active"
    // },
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", star: true, label: "From Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", default: "fs", dateType: "ontype", name: "from_date", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", default: "n", name: "to_date", width: "col-sm-2" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Account Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: false,
    filterable: true,
    formatPDF: {
      colspans: {},
      rowspans: {},
      noborders: {}
    },
    displayColumns: [
      {
        Header: "Date",
        accessor: "date"
      },
      {
        Header: "Particulars",
        accessor: "description",
        width: 400
      },
      {
        Header: "Cheque No",
        accessor: "cheque_no",

      },
      {
        Header: "Type",
        accessor: "ctflag",

      },
      {
        Header: "Batch no",
        accessor: "batch_number"
      },
      {
        Header: "Int Flag",
        accessor: "int_flag"
      },
      {
        Header: "Credit",
        accessor: "credit",
        type: "currency"
      },
      {
        Header: "Debit",
        accessor: "debit",
        type: "currency"
      },
      {
        Header: "Balance",
        accessor: "balance",
        type: "currency"
      },
    ]
  }
};

export default rp102;
